import { getRoute, useLayout } from '@/functions';

export default {
    path: '/',
    component: useLayout('main'),
    children: [
        getRoute('/', 'accountsLanding', 'landing/landing_page', { title: 'Accounts' }),
    ],
};